export default __webpack_public_path__ + "static/duration-breakdown-light-mode-31d9ebdfaa6589013e35991fe9fcecdc.png";